import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import PortalVue from 'portal-vue'
import vueHeadful from 'vue-headful'
import store from './store'
import axios from 'axios'
import VueAxios from "vue-axios"
import VueCookies from 'vue-cookies'
import VueSignaturePad from 'vue-signature-pad'
import './registerServiceWorker'
import {api} from "@/config/api";
import 'vue-pdf-app/dist/icons/main.css';

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'


import 'babel-polyfill'
import Es6Promise from 'es6-promise'

require('es6-promise').polyfill()
Es6Promise.polyfill()

window.axios = require('axios')

Vue.config.productionTip = false
Vue.use(PortalVue, VueAxios, axios, VueCookies)
Vue.use(VueSignaturePad)
Vue.component('vue-headful', vueHeadful)

// axios.defaults.baseURL = 'https://grafgruppe-api.app/'
axios.defaults.baseURL = api.url

Vue.filter('parsePrice', function(price) {
  return parseFloat(price).toLocaleString('de', {minimumFractionDigits: 2})
})

Vue.filter('parsePrice2Digits', function(price) {
  return parseFloat(price).toLocaleString('de', {maximumFractionDigits: 2, minimumFractionDigits: 2})
})

Vue.filter('parsePrice3Digits', function(price) {
    return parseFloat(price).toLocaleString('de', {maximumFractionDigits: 3, minimumFractionDigits: 3})
})

Vue.filter('capitalize', function(text) {
  let firstChar = text.charAt(0).toUpperCase()
  let rest = text.slice(1).toLowerCase()
    if(firstChar+rest === 'Flasche') {
        return firstChar+rest+'(n)'
    }
  return firstChar+rest
})

Vue.filter('parseDate', function(date) {
  return new Date(date).toLocaleString('de', {day: '2-digit', month: '2-digit', year: 'numeric'})
})


if(!store.state.logged && localStorage.getItem('token')) {
  let token_expiration = JSON.parse(localStorage.getItem('token')).expiration
  if(token_expiration < new Date().toISOString()) {
    let token = JSON.parse(localStorage.getItem('token')).token
    store.dispatch('autoLogout', {token: token})
  }
  else {
    store.dispatch('reinitializeLogin')
  }
}

axios.interceptors.request.use(function(config) {

  const token = localStorage.getItem('token');

  if(token !== null) {
    const bearerToken = JSON.parse(localStorage.getItem('token'));
    const bearer = "Bearer " + bearerToken.token;
    config.headers.Authorization = bearer;
  }

  return config
})


axios.interceptors.response.use(
  response => response,
  function(error) {
    if(error.response.status === 400 || error.response.status === 401 || error.response.status === 403) {
      this.$store.state.loginInfoText = 'Logindaten fehlerhaft'
      router.push({name: 'Login'})
    }
    else if(error.response.status === 408 || error.code === 'ECONNABORTED') {
      console.log("Request timed out")
    }
    else if(error.response.status === 404) {
      console.log("not found")
    }
    else if(error.request) {
      console.log("Der Server ist momentan leider nicht erreichbar.")
      //this.$store.state.loginInfoText = 'Der Server ist momentan leider nicht erreichbar.'
    }
    return Promise.reject(error.response)
})

new Vue({
  vuetify,
  router,
  PortalVue,
  store,
  render: h => h(App)
}).$mount('#app')


